import { render, staticRenderFns } from "./SqlErpIntegracao.vue?vue&type=template&id=27eb3ad2"
import script from "./SqlErpIntegracao.vue?vue&type=script&lang=js"
export * from "./SqlErpIntegracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports